<script lang="ts" setup>
const route = useRoute();
const router = useRouter();
const globalLoading = useLoadingStore();
const utmStore = useUtmStore();
const { t } = useI18n();

// Nitro OAuth 启动端点：同源 /api/oauth/google?returnUrl=...
function buildLoginUrl() {
    const params = new URLSearchParams();
    const redirect = (route.query.redirect as string) || '/my/account';
    params.append('returnUrl', redirect);
    const utmAll = new URLSearchParams(utmStore.utmParams).toString();
    if (utmAll) params.append('utm_all', utmAll);
    return `/api/oauth/google?${params.toString()}`;
}

const loginUrl = computed(() => buildLoginUrl());

const loginWithGoogle = () => {
    globalLoading.startLoading();
    window.location.href = loginUrl.value;
};

router.afterEach(() => {
    globalLoading.stopLoading();
});
</script>

<template>
    <v-btn @click="loginWithGoogle" class="w-full bg-neutral-200 text-neutral-950 max-w-[425px] py-3 rounded-full text-lg font-semibold my-5">
        <img src="/public/icon/google-logo.svg" class="h-6 w-6 mr-2" alt="Google Login" />
        {{ t('common.continue_google') }}
    </v-btn>
</template>

<style scoped></style>